const __WEBPACK_NAMESPACE_OBJECT__ = require("@fontsource/inter/900.css");